import { configureStore } from '@reduxjs/toolkit';

// New Redux Toolkit slices
import authSliceReducer from '../features/auth/model/auth-slice';
import eventsReducer from '../features/events/model/events-slice';
import companiesReducer from '../features/companies/model/companies-slice';
import visitorsReducer from '../features/visitors/model/visitors-slice';

import {
    authLegacyReducer,
    postsLegacyReducer,
    sideMenuLegacyReducer,
    todoLegacyReducer,
} from './legacyCompatReducers';

export const store = configureStore({
    reducer: {
        // Old reducers (backward compatibility - keep existing state structure)
        auth: authLegacyReducer, // Keeps state.auth.* contract for legacy screens
        posts: postsLegacyReducer,
        sideMenu: sideMenuLegacyReducer,
        todoReducers: todoLegacyReducer,

        // New Redux Toolkit slices (using different keys to avoid conflicts)
        authSlice: authSliceReducer, // New auth slice at state.authSlice
        events: eventsReducer,
        companies: companiesReducer,
        visitors: visitorsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['auth/login/fulfilled', 'auth/signup/fulfilled'],
                // Ignore these field paths in all actions
                ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
                // Ignore these paths in the state
                ignoredPaths: ['items.dates'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
